import React from 'react';
import { Typography } from '@material-ui/core';

const TypographyField = ({ label, variant }) => (
  <Typography variant={variant}>{label}</Typography>
);

TypographyField.defaultProps = {
  addLabel: false,
  variant: 'h6',
};

export default TypographyField;
